module.exports = __webpack_public_path__ + "img/675c54de-27f5-430f-8e44-7febc0a6fe77.905ab005.webp";